module.exports = __webpack_public_path__ + "img/road.0490215f.png";